import { Component, OnDestroy } from '@angular/core';
import { AuthService } from '../services/auth.service';
import { RoleService } from '../services/role.service';
import { TokenStorageService } from '../services/token-storage.service';
import { FormGroup, FormControl, Validators } from "@angular/forms";
import { Router } from "@angular/router";
import { CategoryService } from '../services/category.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-login',
  templateUrl: './app.login.component.html',
})
export class AppLoginComponent implements OnDestroy {

  private destroy$ = new Subject<void>();
  type = 'admin';
  form: any = {
    username: null,
    password: null
  };
  isLoggedIn = false;
  isLoginFailed = false;
  errorMessage = '';
  userData: any = {};
  roles: string[] = [];
  loading: boolean;
  public rolelist: any[] = [];
  public permissions;
  public roleId;
  parentcatList: any[] = [];
  loginform = new FormGroup({
    email: new FormControl("", [Validators.required]),
    password: new FormControl("", [Validators.required])

  });

  constructor(
    private authService: AuthService,
    private roleService: RoleService,
    private tokenStorage: TokenStorageService,
    private router: Router,
    private categoryService: CategoryService,
  ) { }

  ngOnInit(): void {
    if (this.tokenStorage.getToken()) {
      this.isLoggedIn = true;
      this.roles = this.tokenStorage.getUser().roles;
    }
  }

  onSubmit(): void {
    const username = this.loginform.value.email;
    const password = this.loginform.value.password;
    this.loading = true;
    this.authService.login(username, password, this.type, false).pipe(takeUntil(this.destroy$)).subscribe(
      data => {
        this.userData = data;
        this.tokenStorage.saveToken(this.userData.data.access_token);
        this.tokenStorage.saveUser(this.userData.data);
        this.tokenStorage.getAuthStatus(this.userData.data);
        this.isLoginFailed = false;
        this.isLoggedIn = true;
        this.roles = this.tokenStorage.getClient();
        this.getRoleList();
        this.getParentCategory();
        this.getRoleDetails();

      },
      err => {
        this.errorMessage = err.error.data.message;
        this.isLoginFailed = true;
      }
    );
  }

  getParentCategory() {
    var query = "?filterByDisable=false&filterByStatus=true&getOnlyParent=true";
    this.categoryService.getCategoryList(query).pipe(takeUntil(this.destroy$)).subscribe(
      data => {
        this.parentcatList = data.data.items;
        this.tokenStorage.saveCategorylist(this.parentcatList);
      },
      err => {
        this.errorMessage = err.error.message;
      }
    );
  }

  getRoleList() {
    var querystring = "filterByDisable=false&filterByStatus=true";
    var rolearray = [];
    this.roleService.getRoleList(querystring).pipe(takeUntil(this.destroy$)).subscribe(
      data => {
        var rolelist = data.data.items;
        rolelist.forEach(element => {
          rolearray.push({ "roleid": element.id, "rolename": element.user_role_name });
        });
        if (rolearray.length > 0) {
          this.tokenStorage.saveRolelist(rolearray);
        }
      },
      err => {
        this.errorMessage = err.error.message;
      }
    );
  }

  async getRoleDetails() {
    const querystring = "filterByroleName=" + this.userData.data.userdata.rolename;
    this.roleService.searchRoleDetails(querystring).pipe(takeUntil(this.destroy$)).subscribe(
      data => {
        this.roleId = data.data.items[0]['id'];
        this.permissions = data.data.items[0]['permissions'];
        //console.log(this.permissions);
        this.tokenStorage.saveUserPermissions(this.permissions);
        this.rolelist = data.data.items[0];
        setTimeout(() => {
          //this.router.navigateByUrl("/manage/dashboard");
          const userRole = this.userData.data.userdata.rolename;
          this.setActiveModule(userRole,this.permissions);
          let currentUrl = this.getCurrentUrl(userRole,this.permissions);
          this.router.routeReuseStrategy.shouldReuseRoute = () => false;
          this.router.onSameUrlNavigation = 'reload';
          this.router.navigate([currentUrl]);
        }, 500);

      },
      err => {
        this.errorMessage = err.error.message;
      }
    );
  }

  setActiveModule(userRole,permissions) {
    const module = { 
      label: (userRole === 'admin' || userRole === 'superadmin') ? 'Dashboard' : permissions[0].module, 
      icon: (userRole === 'admin' || userRole === 'superadmin') ? 'pi pi-home' : 'pi ' + permissions[0].icon, 
      routerLink: (userRole === 'admin' || userRole === 'superadmin') ? ['/manage/dashboard'] : [permissions[0].url], 
      parentModule: (userRole === 'admin' || userRole === 'superadmin') ? 'Dashboard' : permissions[0].module 
    };
    this.tokenStorage.setActiveModule(module);
  }

  getCurrentUrl(userRole,permissions) {
    const url = (Object.keys(permissions[0]).includes('submodule') && permissions[0]['submodule'].length > 0) ? permissions[0]['submodule'][0]['url'] : permissions[0]['url'];
    const currentUrl = (userRole === 'admin' || userRole === 'superadmin') ? '/manage/dashboard' : url;
    return currentUrl;
  }
  cancel() {

  }

  reloadPage(): void {
    window.location.reload();
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

}
